/**
 * Game ids as games and the server send them ('bopamole', 'followthesequence') and their display names.
 * The list mirrors the parameter definition files on the server (server/games/*.json), design order.
 */
export const GAMES = [
    { id: 'bopamole', label: 'Bopamole' },
    { id: 'citadel', label: 'Citadel' },
    { id: 'coinrunner', label: 'Coinrunner' },
    { id: 'colorshot', label: 'Colorshot' },
    { id: 'colorswitch', label: 'Colorswitch' },
    { id: 'followthesequence', label: 'Follow the Sequence' },
    { id: 'gravityballs', label: 'Gravityballs' },
    { id: 'kollect', label: 'Kollect' },
    { id: 'skyburger', label: 'Skyburger' },
    { id: 'spaceshooter', label: 'Spaceshooter' },
    { id: 'assessmentgames', label: 'Assessment games' },
];

const LABELS = Object.fromEntries(GAMES.map((g) => [g.id, g.label]));

/** Display name for a game id ('bopamole' → 'Bopamole'); unknown lowercase ids are title-cased. */
export function gameLabel(id, fallback = 'Unknown game') {
    if (!id) return fallback;
    const s = String(id);
    const known = LABELS[s.toLowerCase().replace(/[\s_-]/g, '')];
    if (known) return known;
    return s === s.toLowerCase() ? s.replace(/(^|[\s_-])([a-z])/g, (m, sep, c) => (sep === '_' || sep === '-' ? ' ' : sep) + c.toUpperCase()) : s;
}
